import { defineStore } from 'pinia'
import router from '@/router'
import { authService } from '@/services/authService'
import { manageErrorResponse, parseJwt } from '@/assets/js/main'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  const response = ref()

  function isAuthenticated() {
    return localStorage.getItem('access_token') !== null
  }

  function userRole() {
    return parseJwt(localStorage.getItem('access_token')).role
  }

  function userUsername() {
    return parseJwt(localStorage.getItem('access_token')).username
  }

  function clean() {
    return localStorage.clear()
  }

  async function logout() {
    localStorage.clear()
    await router.push('/login')
  }

  async function login(email: string, password: string) {
    const response = await authService.signIn(email, password)
    localStorage.setItem('access_token', response.access_token)
  }

  async function profile() {
    try {
      response.value = await authService.profile()
    } catch (e) {
      return manageErrorResponse(e)
    }
  }

  async function updatePassword(params: any) {
    await authService.updatePassword(params)
  }

  async function forgotPassword(email: string) {
    try {
      await authService.forgotPassword(email)
    } catch (e) {
      return manageErrorResponse(e)
    }
  }

  async function validateResetPasswordJwtToken(jwtToken: string) {
    try {
      return await authService.validateResetPasswordJwtToken(jwtToken)
    } catch (e) {
      return manageErrorResponse(e)
    }
  }

  async function resetPassword(password: string, jwtToken: string) {
    try {
      await authService.resetPassword(password, jwtToken)
    } catch (e) {
      return manageErrorResponse(e)
    }
  }

  return {
    response,
    isAuthenticated,
    userRole,
    userUsername,
    clean,
    logout,
    login,
    updatePassword,
    forgotPassword,
    validateResetPasswordJwtToken,
    resetPassword,
    profile
  }
})
